<template>
  <div class="opus_item">
    <img
      :src="opus_obj.cover_thumbnail || opus_obj.image_detailsPath.split('|')[0]"
      alt
      @click="toOpusDetail"
    />
    <!-- 鼠标hover 显示信息栏 -->
    <div class="opus_information">
      <!-- 审核中提醒 -->
      <div
        class="examining"
        v-if="opus_obj && opus_obj.status!=='IdentityCertifieStatussuccess'"
      >{{opus_obj.status_name}}</div>
      <!-- 信息栏 -->
      <div class="opus_information_inner">
        <p>{{opus_obj.name}}</p>
        <span>
          <i class="my_icon eye"></i>
          <span>{{opus_obj.popularity?opus_obj.popularity:'0'}}</span>
        </span>
        <span>
          <i class="my_icon small_praise"></i>
          <span>{{opus_obj.like_count?opus_obj.like_count:'0'}}</span>
        </span>
      </div>
    </div>

    <!-- 个人作品编辑选项 -->
    <div class="opus_options" @click="showOptBtns" v-if="my_opus">
      <i class="el-icon-more"></i>
      <div class="options_btns">
        <div
          class="edit"
          @click.stop="editOpus"
          v-if="opus_obj.status==='IdentityCertifieStatusReturned'"
        >编辑</div>
        <div
          class="hidden"
          v-if="opus_obj.permission==='OpusPermsPublic'"
          @click.stop="hideOpus(false)"
        >隐藏</div>
        <div class="show" v-else @click.stop="hideOpus(true)">取消隐藏</div>
        <!-- <div class="delete" @click.stop="deleteOpus">删除</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      opt_flag: false //右上角操作按钮显示flag
    };
  },
  props: {
    //接受一个bool判断是否为个人作品
    my_opus: {
      type: Boolean
    },
    //作品信息对象
    opus_obj: {
      type: Object,
      default: () => {
        return {
          image_detailsPath: ""
        };
      }
    }
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  methods: {
    // 显示个人作品右上角操作按钮
    showOptBtns() {
      this.opt_flag = !this.opt_flag;
    },
    // 跳转编辑作品页面 附带作品id
    editOpus() {
      this.$router.push({
        name: "upload_final_design",
        query: {
          id: this.opus_obj.id
        }
      });
    },
    // 隐藏作品操作
    hideOpus(flag) {
      let obj = {
        id: this.opus_obj.id,
        permission: flag ? "OpusPermsPublic" : "OpusPermsPrivate"
      };
      this.api.updateOpusPermission(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        this.$message.success(`${flag ? "作品已取消隐藏" : "作品已隐藏"}`);
        this.$router.push({ name: "personal_center_finaly_design_list" });
      });
    },
    // 删除作品按钮
    deleteOpus() {
      this.$confirm("是否删除此作品？", "提示", {
        type: "warning"
      }).then(() => {
        this.delete();
      });
    },
    // 删除作品接口
    delete() {
      let obj = {
        id: this.opus_obj.id,
        active: false
      };
      this.api.updateOpusPermission(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        this.$message.success("作品已删除！");
        this.$router.push({ name: "personal_center_finaly_design_list" });
      });
    },
    // 点击作品跳转详情页面
    toOpusDetail() {
      if (this.opus_obj.status !== "IdentityCertifieStatussuccess") {
        return;
      }
      const { href } = this.$router.resolve({
        name: "pro_detail",
        query: { id: this.opus_obj.id }
      });
      window.open(href, "_blank");
    }
  }
};
</script>
<style lang="scss">
.opus_item {
  width: 274px;
  height: 199px;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  img {
    width: 100%;
    height: 199px;
    object-fit: cover;
  }
  .opus_information {
    position: absolute;
    bottom: -50px;
    width: 100%;
    height: 50px;
    // opacity: 0;
    background-color: #fff;
    transition: all 0.3s;
    // overflow: hidden;
    display: flex;
    align-items: center;
    padding-left: 12px;
    box-sizing: border-box;
    .opus_information_inner {
      p {
        display: inline-block;
        width: 126px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 20px;
        font-size: 13px;
        color: #333;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
        font-size: 12px;
        margin-right: 10px;
        span {
          margin-right: 0;
          color: #aaa;
        }
        i {
          margin-right: 5px;
          vertical-align: middle;
        }
      }
    }
    .examining {
      position: absolute;
      top: -32px;
      left: 0;
      width: 100%;
      height: 32px;
      background: rgba(0, 0, 0, 0.5);
      font-size: 12px;
      color: #fff;
      line-height: 32px;
      text-align: center;
    }
  }

  .opus_options {
    width: 30px;
    height: 20px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    text-align: center;
    line-height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    opacity: 0;
    i {
      color: #555555;
    }
    .options_btns {
      width: 70px;
      opacity: 0;
      background-color: #fff;
      border-radius: 4px;
      position: absolute;
      overflow: hidden;
      right: 0;
      top: 25px;
      overflow: hidden;
      transition: all 0.3s;
      div {
        height: 30px;
        line-height: 30px;
      }
      div:hover {
        background: rgba(245, 245, 245, 1);
      }
    }
  }
}
.opus_item:hover .opus_information{
   bottom: 0;
} 
.opus_item:hover .opus_options{
   opacity: 1;
} 


.opus_options:hover .options_btns{
   opacity: 1;
}
.options_btns:hover{
   opacity: 1;
}
 .opus_options i:hover + .options_btns{
    opacity: 1;
 }

</style>